<template>
  <v-container grid-list-md>
    <v-card class="mb-2">
      <v-card-title class="title">Mon compte</v-card-title>
    </v-card>
    <v-layout row v-for="item in kbitems" :key="item._id">
      <v-flex xs12>
        <KbitemEdit
          v-if="editing === item._id"
          :orig-title="item.title"
          :orig-content="item.content"
          :orig-id="item._id"
          @cancel="editing = -1"
          @update="reload()"
        ></KbitemEdit>
        <v-sheet elevation="1" v-else>
          <Kbitem :item="item" @edit="editing = item._id" />
        </v-sheet>
      </v-flex>
    </v-layout>
    <KbitemEdit v-if="showAdd" @cancel="showAdd = false" @update="reload()" />
    <v-btn
      v-if="isAdminOrSuperAdmin && !showAdd"
      fixed
      dark
      fab
      bottom
      right
      color="accent"
      @click="showAdd = true"
      style="bottom: 10px"
      ><v-icon>add</v-icon></v-btn
    ></v-container
  >
</template>

<script>
import { EXTERNAL_URL } from "../../../webapp-commons/config";
import KbitemEdit from "../components/kbitems/KbitemEdit";
import Kbitem from "../components/kbitems/Kbitem";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "KnowledgeBase.vue",
  components: {
    KbitemEdit,
    Kbitem
  },
  data() {
    return {
      editing: -1,
      showAdd: false,
      extUrl: EXTERNAL_URL
    };
  },
  mounted() {
    this.reload();
  },
  computed: {
    ...mapState("kb", ["kbitems"]),
    ...mapGetters("user", ["isAdminOrSuperAdmin"])
  },
  methods: {
    ...mapActions("kb", ["fetchKbItems"]),
    reload() {
      this.fetchKbItems();
      this.editing = -1;
      this.showAdd = false;
    }
  }
};
</script>
